// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/invoice.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CreateDealForDocumentRequest, DealQuotation, DocumentDealResponse } from "./deal_pb";
import { file_api_proto_v1_deal } from "./deal_pb";
import type { ImageResponse } from "./image_pb";
import { file_api_proto_v1_image } from "./image_pb";
import type { Order } from "./list_pb";
import { file_api_proto_v1_list } from "./list_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/invoice.proto.
 */
export const file_api_proto_v1_invoice: GenFile = /*@__PURE__*/
  fileDesc("ChphcGlfcHJvdG8vdjEvaW52b2ljZS5wcm90bxIMYXBpX3Byb3RvLnYxIt4CCg1JbnZvaWNlRGV0YWlsEjEKC2Rlc2NyaXB0aW9uGAEgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEiwKBnJlbWFyaxgCIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIuCghxdWFudGl0eRgDIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5Eb3VibGVWYWx1ZRIqCgR1bml0GAQgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEi8KCnVuaXRfcHJpY2UYBSABKAsyGy5nb29nbGUucHJvdG9idWYuSW50NjRWYWx1ZRITCgtvcmRlcl9pbmRleBgGIAEoAxI3Cg50cmFuc2FjdGlvbl9hdBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBAUIRCg9fdHJhbnNhY3Rpb25fYXQizwEKEkludm9pY2VEZXRhaWxHcm91cBIMCgRuYW1lGAEgASgJEiwKBnJlbWFyaxgCIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRITCgtvcmRlcl9pbmRleBgDIAEoAxIsCgdkZXRhaWxzGAQgAygLMhsuYXBpX3Byb3RvLnYxLkludm9pY2VEZXRhaWwSDgoGYW1vdW50GAUgASgBEhIKCmFkanVzdG1lbnQYBiABKAMSFgoOYWRqdXN0bWVudF90YXgYByABKAMizwoKFENyZWF0ZUludm9pY2VSZXF1ZXN0EioKBG5hbWUYASABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSLAoGbnVtYmVyGAIgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEi4KCmludm9pY2VfYXQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjIKCWV4cGlyZV9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBARIsCgZyZW1hcmsYBSABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSFAoMY29tcGFueV9uYW1lGAYgASgJEjUKD2NvbXBhbnlfYWRkcmVzcxgHIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRI1Cg9jb21wYW55X2NvbnRhY3QYCCABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSQQobY29tcGFueV9yZWdpc3RyYXRpb25fbnVtYmVyGAkgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjoKFGNvbXBhbnlfYmFua19hY2NvdW50GAogASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjQKD2NvbXBhbnlfbG9nb19pZBgLIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQ2NFZhbHVlEjQKD2NvbXBhbnlfc2VhbF9pZBgMIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQ2NFZhbHVlEhMKC2N1c3RvbWVyX2lkGA0gASgDEhUKDWN1c3RvbWVyX25hbWUYDiABKAkSEQoJaG9ub3JpZmljGA8gASgJEjYKEGN1c3RvbWVyX3ppcGNvZGUYECABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSOQoTY3VzdG9tZXJfcHJlZmVjdHVyZRgRIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIzCg1jdXN0b21lcl9jaXR5GBIgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjUKD2N1c3RvbWVyX3N0cmVldBgTIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRI5ChNjdXN0b21lcl9kZXBhcnRtZW50GBUgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEj0KF2N1c3RvbWVyX2NvbnRhY3RfcGVyc29uGBYgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEhgKEGNvbXBhbnlfc3RhZmZfaWQYFyABKAMSEwoLZm9ybWF0X3R5cGUYGCABKAkSLAoHZGV0YWlscxgZIAMoCzIbLmFwaV9wcm90by52MS5JbnZvaWNlRGV0YWlsEjcKDWRldGFpbF9ncm91cHMYGiADKAsyIC5hcGlfcHJvdG8udjEuSW52b2ljZURldGFpbEdyb3VwEjMKCnBheW1lbnRfYXQYGyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAGIAQESEgoKYWRqdXN0bWVudBgcIAEoAxIWCg5hZGp1c3RtZW50X3RheBgdIAEoAxITCgtsYXlvdXRfdHlwZRgeIAEoCRIbChN0cmFuc2Zlcl9mZWVfYmVhcmVyGB8gASgJQgwKCl9leHBpcmVfYXRCDQoLX3BheW1lbnRfYXQiPQoVQ3JlYXRlSW52b2ljZVJlc3BvbnNlEgoKAmlkGAEgASgDEhgKEG51bWJlcl9kdXBsaWNhdGUYAiABKAgiHgocR2VuZXJhdGVJbnZvaWNlTnVtYmVyUmVxdWVzdCJjCh1HZW5lcmF0ZUludm9pY2VOdW1iZXJSZXNwb25zZRIOCgZudW1iZXIYASABKAkSGAoQbGFzdF9mb3JtYXRfdHlwZRgCIAEoCRIYChBsYXN0X2xheW91dF90eXBlGAMgASgJIswDCg9JbnZvaWNlTGlzdEl0ZW0SCgoCaWQYASABKAMSDAoEbmFtZRgCIAEoCRIOCgZudW1iZXIYAyABKAkSFQoNY3VzdG9tZXJfbmFtZRgEIAEoCRIuCgppbnZvaWNlX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBItCglleHBpcmVfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnBheW1lbnRfYXQYByABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhQKDHRvdGFsX2Ftb3VudBgIIAEoARIQCgh0YXhfcmF0ZRgJIAEoARISCgphZGp1c3RtZW50GAogASgDEhYKDmFkanVzdG1lbnRfdGF4GAsgASgDEh0KFWFkanVzdGVkX3RvdGFsX2Ftb3VudBgMIAEoARI1CgRkZWFsGA0gASgLMiIuYXBpX3Byb3RvLnYxLkRvY3VtZW50RGVhbFJlc3BvbnNlSACIAQESNgoRbGlua2VkX3F1b3RhdGlvbnMYDiADKAsyGy5hcGlfcHJvdG8udjEuRGVhbFF1b3RhdGlvbkIHCgVfZGVhbCJdChZHZXRJbnZvaWNlTGlzdFJlc3BvbnNlEi8KCGludm9pY2VzGAEgAygLMh0uYXBpX3Byb3RvLnYxLkludm9pY2VMaXN0SXRlbRISCgp0b3RhbF9wYWdlGAIgASgDIrQCChVHZXRJbnZvaWNlTGlzdFJlcXVlc3QSDAoEcGFnZRgBIAEoAxIRCglwYWdlX3NpemUYAiABKAMSEgoKZnJlZV93b3JkcxgDIAMoCRIpCgxudW1iZXJfb3JkZXIYBCABKA4yEy5hcGlfcHJvdG8udjEuT3JkZXISLQoQaW52b2ljZV9hdF9vcmRlchgFIAEoDjITLmFwaV9wcm90by52MS5PcmRlchIsCg9leHBpcmVfYXRfb3JkZXIYBiABKA4yEy5hcGlfcHJvdG8udjEuT3JkZXISLQoQcGF5bWVudF9hdF9vcmRlchgHIAEoDjITLmFwaV9wcm90by52MS5PcmRlchIvChJ0b3RhbF9hbW91bnRfb3JkZXIYCCABKA4yEy5hcGlfcHJvdG8udjEuT3JkZXIiHwoRR2V0SW52b2ljZVJlcXVlc3QSCgoCaWQYASABKAMivwsKEkdldEludm9pY2VSZXNwb25zZRIKCgJpZBgBIAEoAxIqCgRuYW1lGAIgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEiwKBm51bWJlchgDIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIuCgppbnZvaWNlX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBItCglleHBpcmVfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiwKBnJlbWFyaxgGIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIUCgxjb21wYW55X25hbWUYByABKAkSNQoPY29tcGFueV9hZGRyZXNzGAggASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjUKD2NvbXBhbnlfY29udGFjdBgJIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRJBChtjb21wYW55X3JlZ2lzdHJhdGlvbl9udW1iZXIYCiABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSOgoUY29tcGFueV9iYW5rX2FjY291bnQYCyABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSLgoEbG9nbxgMIAEoCzIbLmFwaV9wcm90by52MS5JbWFnZVJlc3BvbnNlSACIAQESLgoEc2VhbBgNIAEoCzIbLmFwaV9wcm90by52MS5JbWFnZVJlc3BvbnNlSAGIAQESEwoLY3VzdG9tZXJfaWQYDiABKAMSFQoNY3VzdG9tZXJfbmFtZRgPIAEoCRIRCglob25vcmlmaWMYECABKAkSNgoQY3VzdG9tZXJfemlwY29kZRgRIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRI5ChNjdXN0b21lcl9wcmVmZWN0dXJlGBIgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjMKDWN1c3RvbWVyX2NpdHkYEyABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSNQoPY3VzdG9tZXJfc3RyZWV0GBQgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjkKE2N1c3RvbWVyX2RlcGFydG1lbnQYFiABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSPQoXY3VzdG9tZXJfY29udGFjdF9wZXJzb24YFyABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSGAoQY29tcGFueV9zdGFmZl9pZBgYIAEoAxIQCgh0YXhfcmF0ZRgZIAEoARIUCgx0b3RhbF9hbW91bnQYGiABKAESEwoLZm9ybWF0X3R5cGUYGyABKAkSLAoHZGV0YWlscxgcIAMoCzIbLmFwaV9wcm90by52MS5JbnZvaWNlRGV0YWlsEjcKDWRldGFpbF9ncm91cHMYHSADKAsyIC5hcGlfcHJvdG8udjEuSW52b2ljZURldGFpbEdyb3VwEi4KCnBheW1lbnRfYXQYHiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjUKBGRlYWwYHyABKAsyIi5hcGlfcHJvdG8udjEuRG9jdW1lbnREZWFsUmVzcG9uc2VIAogBARISCgphZGp1c3RtZW50GCAgASgDEhYKDmFkanVzdG1lbnRfdGF4GCEgASgDEh0KFWFkanVzdGVkX3RvdGFsX2Ftb3VudBgiIAEoARITCgtsYXlvdXRfdHlwZRgjIAEoCRIbChN0cmFuc2Zlcl9mZWVfYmVhcmVyGCQgASgJQgcKBV9sb2dvQgcKBV9zZWFsQgcKBV9kZWFsItsKChRVcGRhdGVJbnZvaWNlUmVxdWVzdBIKCgJpZBgBIAEoAxIqCgRuYW1lGAIgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEiwKBm51bWJlchgDIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIuCgppbnZvaWNlX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIyCglleHBpcmVfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSACIAQESLAoGcmVtYXJrGAYgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEhQKDGNvbXBhbnlfbmFtZRgHIAEoCRI1Cg9jb21wYW55X2FkZHJlc3MYCCABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSNQoPY29tcGFueV9jb250YWN0GAkgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEkEKG2NvbXBhbnlfcmVnaXN0cmF0aW9uX251bWJlchgKIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRI6ChRjb21wYW55X2JhbmtfYWNjb3VudBgLIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRI0Cg9jb21wYW55X2xvZ29faWQYDCABKAsyGy5nb29nbGUucHJvdG9idWYuSW50NjRWYWx1ZRI0Cg9jb21wYW55X3NlYWxfaWQYDSABKAsyGy5nb29nbGUucHJvdG9idWYuSW50NjRWYWx1ZRITCgtjdXN0b21lcl9pZBgOIAEoAxIVCg1jdXN0b21lcl9uYW1lGA8gASgJEhEKCWhvbm9yaWZpYxgQIAEoCRI2ChBjdXN0b21lcl96aXBjb2RlGBEgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjkKE2N1c3RvbWVyX3ByZWZlY3R1cmUYEiABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSMwoNY3VzdG9tZXJfY2l0eRgTIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRI1Cg9jdXN0b21lcl9zdHJlZXQYFCABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSOQoTY3VzdG9tZXJfZGVwYXJ0bWVudBgWIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRI9ChdjdXN0b21lcl9jb250YWN0X3BlcnNvbhgXIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIYChBjb21wYW55X3N0YWZmX2lkGBggASgDEhMKC2Zvcm1hdF90eXBlGBkgASgJEiwKB2RldGFpbHMYGiADKAsyGy5hcGlfcHJvdG8udjEuSW52b2ljZURldGFpbBI3Cg1kZXRhaWxfZ3JvdXBzGBsgAygLMiAuYXBpX3Byb3RvLnYxLkludm9pY2VEZXRhaWxHcm91cBIzCgpwYXltZW50X2F0GBwgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgBiAEBEhIKCmFkanVzdG1lbnQYHSABKAMSFgoOYWRqdXN0bWVudF90YXgYHiABKAMSEwoLbGF5b3V0X3R5cGUYHyABKAkSGwoTdHJhbnNmZXJfZmVlX2JlYXJlchggIAEoCUIMCgpfZXhwaXJlX2F0Qg0KC19wYXltZW50X2F0Ij0KFVVwZGF0ZUludm9pY2VSZXNwb25zZRIKCgJpZBgBIAEoAxIYChBudW1iZXJfZHVwbGljYXRlGAIgASgIIiIKFERlbGV0ZUludm9pY2VSZXF1ZXN0EgoKAmlkGAEgASgDIlQKGExpbmtEZWFsVG9JbnZvaWNlUmVxdWVzdBISCgppbnZvaWNlX2lkGAEgASgDEg8KB2RlYWxfaWQYAiABKAMSEwoLd2FudF91cGRhdGUYAyABKAgiQAoZTGlua0RlYWxUb0ludm9pY2VSZXNwb25zZRISCgppbnZvaWNlX2lkGAEgASgDEg8KB2RlYWxfaWQYAiABKAMicQohQ3JlYXRlQW5kTGlua0RlYWxUb0ludm9pY2VSZXF1ZXN0EhIKCmludm9pY2VfaWQYASABKAMSOAoEZGVhbBgCIAEoCzIqLmFwaV9wcm90by52MS5DcmVhdGVEZWFsRm9yRG9jdW1lbnRSZXF1ZXN0IjIKHFVubGlua0RlYWxGcm9tSW52b2ljZVJlcXVlc3QSEgoKaW52b2ljZV9pZBgBIAEoA0IzWjFnaXRodWIuY29tL2gtc2NhcGUvaWVzYXB1cmkvZ28vYXBpX3Byb3RvL3YxO2FwaXYxYgZwcm90bzM", [file_api_proto_v1_deal, file_api_proto_v1_image, file_api_proto_v1_list, file_google_protobuf_timestamp, file_google_protobuf_wrappers]);

/**
 * @generated from message api_proto.v1.InvoiceDetail
 */
export type InvoiceDetail = Message<"api_proto.v1.InvoiceDetail"> & {
  /**
   * @generated from field: google.protobuf.StringValue description = 1;
   */
  description?: string;

  /**
   * @generated from field: google.protobuf.StringValue remark = 2;
   */
  remark?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue quantity = 3;
   */
  quantity?: number;

  /**
   * @generated from field: google.protobuf.StringValue unit = 4;
   */
  unit?: string;

  /**
   * @generated from field: google.protobuf.Int64Value unit_price = 5;
   */
  unitPrice?: bigint;

  /**
   * @generated from field: int64 order_index = 6;
   */
  orderIndex: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp transaction_at = 7;
   */
  transactionAt?: Timestamp;
};

/**
 * Describes the message api_proto.v1.InvoiceDetail.
 * Use `create(InvoiceDetailSchema)` to create a new message.
 */
export const InvoiceDetailSchema: GenMessage<InvoiceDetail> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 0);

/**
 * @generated from message api_proto.v1.InvoiceDetailGroup
 */
export type InvoiceDetailGroup = Message<"api_proto.v1.InvoiceDetailGroup"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.StringValue remark = 2;
   */
  remark?: string;

  /**
   * @generated from field: int64 order_index = 3;
   */
  orderIndex: bigint;

  /**
   * @generated from field: repeated api_proto.v1.InvoiceDetail details = 4;
   */
  details: InvoiceDetail[];

  /**
   * @generated from field: double amount = 5;
   */
  amount: number;

  /**
   * 端数調整(税抜)
   *
   * @generated from field: int64 adjustment = 6;
   */
  adjustment: bigint;

  /**
   * 端数調整(税込)
   *
   * @generated from field: int64 adjustment_tax = 7;
   */
  adjustmentTax: bigint;
};

/**
 * Describes the message api_proto.v1.InvoiceDetailGroup.
 * Use `create(InvoiceDetailGroupSchema)` to create a new message.
 */
export const InvoiceDetailGroupSchema: GenMessage<InvoiceDetailGroup> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 1);

/**
 * @generated from message api_proto.v1.CreateInvoiceRequest
 */
export type CreateInvoiceRequest = Message<"api_proto.v1.CreateInvoiceRequest"> & {
  /**
   * @generated from field: google.protobuf.StringValue name = 1;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue number = 2;
   */
  number?: string;

  /**
   * @generated from field: google.protobuf.Timestamp invoice_at = 3;
   */
  invoiceAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp expire_at = 4;
   */
  expireAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue remark = 5;
   */
  remark?: string;

  /**
   * @generated from field: string company_name = 6;
   */
  companyName: string;

  /**
   * @generated from field: google.protobuf.StringValue company_address = 7;
   */
  companyAddress?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_contact = 8;
   */
  companyContact?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_registration_number = 9;
   */
  companyRegistrationNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_bank_account = 10;
   */
  companyBankAccount?: string;

  /**
   * @generated from field: google.protobuf.Int64Value company_logo_id = 11;
   */
  companyLogoId?: bigint;

  /**
   * @generated from field: google.protobuf.Int64Value company_seal_id = 12;
   */
  companySealId?: bigint;

  /**
   * @generated from field: int64 customer_id = 13;
   */
  customerId: bigint;

  /**
   * @generated from field: string customer_name = 14;
   */
  customerName: string;

  /**
   * @generated from field: string honorific = 15;
   */
  honorific: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_zipcode = 16;
   */
  customerZipcode?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_prefecture = 17;
   */
  customerPrefecture?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_city = 18;
   */
  customerCity?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_street = 19;
   */
  customerStreet?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_department = 21;
   */
  customerDepartment?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_contact_person = 22;
   */
  customerContactPerson?: string;

  /**
   * @generated from field: int64 company_staff_id = 23;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: string format_type = 24;
   */
  formatType: string;

  /**
   * format_typeがsingleの場合details、multipleの場合detail_groupsがセットされる
   *
   * @generated from field: repeated api_proto.v1.InvoiceDetail details = 25;
   */
  details: InvoiceDetail[];

  /**
   * @generated from field: repeated api_proto.v1.InvoiceDetailGroup detail_groups = 26;
   */
  detailGroups: InvoiceDetailGroup[];

  /**
   * @generated from field: optional google.protobuf.Timestamp payment_at = 27;
   */
  paymentAt?: Timestamp;

  /**
   * 端数調整
   *
   * 端数調整(税抜)
   *
   * @generated from field: int64 adjustment = 28;
   */
  adjustment: bigint;

  /**
   * 端数調整(税込)
   *
   * @generated from field: int64 adjustment_tax = 29;
   */
  adjustmentTax: bigint;

  /**
   * レイアウトタイプ: normal=通常, windowed=窓付封筒
   *
   * @generated from field: string layout_type = 30;
   */
  layoutType: string;

  /**
   * 振込手数料の負担者。帳票の振込先欄の直下に注意書きとして表示する
   * ""=表示しない / "customer"=先方負担 / "company"=当方負担
   *
   * @generated from field: string transfer_fee_bearer = 31;
   */
  transferFeeBearer: string;
};

/**
 * Describes the message api_proto.v1.CreateInvoiceRequest.
 * Use `create(CreateInvoiceRequestSchema)` to create a new message.
 */
export const CreateInvoiceRequestSchema: GenMessage<CreateInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 2);

/**
 * @generated from message api_proto.v1.CreateInvoiceResponse
 */
export type CreateInvoiceResponse = Message<"api_proto.v1.CreateInvoiceResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * 請求書番号が重複していた場合true
   *
   * @generated from field: bool number_duplicate = 2;
   */
  numberDuplicate: boolean;
};

/**
 * Describes the message api_proto.v1.CreateInvoiceResponse.
 * Use `create(CreateInvoiceResponseSchema)` to create a new message.
 */
export const CreateInvoiceResponseSchema: GenMessage<CreateInvoiceResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 3);

/**
 * @generated from message api_proto.v1.GenerateInvoiceNumberRequest
 */
export type GenerateInvoiceNumberRequest = Message<"api_proto.v1.GenerateInvoiceNumberRequest"> & {
};

/**
 * Describes the message api_proto.v1.GenerateInvoiceNumberRequest.
 * Use `create(GenerateInvoiceNumberRequestSchema)` to create a new message.
 */
export const GenerateInvoiceNumberRequestSchema: GenMessage<GenerateInvoiceNumberRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 4);

/**
 * @generated from message api_proto.v1.GenerateInvoiceNumberResponse
 */
export type GenerateInvoiceNumberResponse = Message<"api_proto.v1.GenerateInvoiceNumberResponse"> & {
  /**
   * @generated from field: string number = 1;
   */
  number: string;

  /**
   * 最後に使用した書類のフォーマット種別（"single" | "multiple"）。過去書類なければ空文字
   *
   * @generated from field: string last_format_type = 2;
   */
  lastFormatType: string;

  /**
   * 最後に使用した書類のレイアウト種別（"normal" | "windowed"）。過去書類なければ空文字
   *
   * @generated from field: string last_layout_type = 3;
   */
  lastLayoutType: string;
};

/**
 * Describes the message api_proto.v1.GenerateInvoiceNumberResponse.
 * Use `create(GenerateInvoiceNumberResponseSchema)` to create a new message.
 */
export const GenerateInvoiceNumberResponseSchema: GenMessage<GenerateInvoiceNumberResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 5);

/**
 * @generated from message api_proto.v1.InvoiceListItem
 */
export type InvoiceListItem = Message<"api_proto.v1.InvoiceListItem"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string number = 3;
   */
  number: string;

  /**
   * @generated from field: string customer_name = 4;
   */
  customerName: string;

  /**
   * @generated from field: google.protobuf.Timestamp invoice_at = 5;
   */
  invoiceAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expire_at = 6;
   */
  expireAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp payment_at = 7;
   */
  paymentAt?: Timestamp;

  /**
   * @generated from field: double total_amount = 8;
   */
  totalAmount: number;

  /**
   * @generated from field: double tax_rate = 9;
   */
  taxRate: number;

  /**
   * 端数調整
   *
   * 端数調整(税抜)
   *
   * @generated from field: int64 adjustment = 10;
   */
  adjustment: bigint;

  /**
   * 端数調整(税込)
   *
   * @generated from field: int64 adjustment_tax = 11;
   */
  adjustmentTax: bigint;

  /**
   * 調整後合計金額
   *
   * @generated from field: double adjusted_total_amount = 12;
   */
  adjustedTotalAmount: number;

  /**
   * 紐づく案件（未紐付けの場合は未設定）。案件名・ステータスを表示し、案件詳細へ遷移する
   *
   * @generated from field: optional api_proto.v1.DocumentDealResponse deal = 13;
   */
  deal?: DocumentDealResponse;

  /**
   * 紐づく案件に連携された見積書一覧（案件未紐付けなら空）
   *
   * @generated from field: repeated api_proto.v1.DealQuotation linked_quotations = 14;
   */
  linkedQuotations: DealQuotation[];
};

/**
 * Describes the message api_proto.v1.InvoiceListItem.
 * Use `create(InvoiceListItemSchema)` to create a new message.
 */
export const InvoiceListItemSchema: GenMessage<InvoiceListItem> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 6);

/**
 * @generated from message api_proto.v1.GetInvoiceListResponse
 */
export type GetInvoiceListResponse = Message<"api_proto.v1.GetInvoiceListResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.InvoiceListItem invoices = 1;
   */
  invoices: InvoiceListItem[];

  /**
   * @generated from field: int64 total_page = 2;
   */
  totalPage: bigint;
};

/**
 * Describes the message api_proto.v1.GetInvoiceListResponse.
 * Use `create(GetInvoiceListResponseSchema)` to create a new message.
 */
export const GetInvoiceListResponseSchema: GenMessage<GetInvoiceListResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 7);

/**
 * @generated from message api_proto.v1.GetInvoiceListRequest
 */
export type GetInvoiceListRequest = Message<"api_proto.v1.GetInvoiceListRequest"> & {
  /**
   * @generated from field: int64 page = 1;
   */
  page: bigint;

  /**
   * @generated from field: int64 page_size = 2;
   */
  pageSize: bigint;

  /**
   * @generated from field: repeated string free_words = 3;
   */
  freeWords: string[];

  /**
   * @generated from field: api_proto.v1.Order number_order = 4;
   */
  numberOrder: Order;

  /**
   * @generated from field: api_proto.v1.Order invoice_at_order = 5;
   */
  invoiceAtOrder: Order;

  /**
   * @generated from field: api_proto.v1.Order expire_at_order = 6;
   */
  expireAtOrder: Order;

  /**
   * @generated from field: api_proto.v1.Order payment_at_order = 7;
   */
  paymentAtOrder: Order;

  /**
   * @generated from field: api_proto.v1.Order total_amount_order = 8;
   */
  totalAmountOrder: Order;
};

/**
 * Describes the message api_proto.v1.GetInvoiceListRequest.
 * Use `create(GetInvoiceListRequestSchema)` to create a new message.
 */
export const GetInvoiceListRequestSchema: GenMessage<GetInvoiceListRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 8);

/**
 * @generated from message api_proto.v1.GetInvoiceRequest
 */
export type GetInvoiceRequest = Message<"api_proto.v1.GetInvoiceRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.GetInvoiceRequest.
 * Use `create(GetInvoiceRequestSchema)` to create a new message.
 */
export const GetInvoiceRequestSchema: GenMessage<GetInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 9);

/**
 * @generated from message api_proto.v1.GetInvoiceResponse
 */
export type GetInvoiceResponse = Message<"api_proto.v1.GetInvoiceResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: google.protobuf.StringValue name = 2;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue number = 3;
   */
  number?: string;

  /**
   * @generated from field: google.protobuf.Timestamp invoice_at = 4;
   */
  invoiceAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expire_at = 5;
   */
  expireAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue remark = 6;
   */
  remark?: string;

  /**
   * @generated from field: string company_name = 7;
   */
  companyName: string;

  /**
   * @generated from field: google.protobuf.StringValue company_address = 8;
   */
  companyAddress?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_contact = 9;
   */
  companyContact?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_registration_number = 10;
   */
  companyRegistrationNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_bank_account = 11;
   */
  companyBankAccount?: string;

  /**
   * @generated from field: optional api_proto.v1.ImageResponse logo = 12;
   */
  logo?: ImageResponse;

  /**
   * @generated from field: optional api_proto.v1.ImageResponse seal = 13;
   */
  seal?: ImageResponse;

  /**
   * @generated from field: int64 customer_id = 14;
   */
  customerId: bigint;

  /**
   * @generated from field: string customer_name = 15;
   */
  customerName: string;

  /**
   * @generated from field: string honorific = 16;
   */
  honorific: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_zipcode = 17;
   */
  customerZipcode?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_prefecture = 18;
   */
  customerPrefecture?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_city = 19;
   */
  customerCity?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_street = 20;
   */
  customerStreet?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_department = 22;
   */
  customerDepartment?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_contact_person = 23;
   */
  customerContactPerson?: string;

  /**
   * @generated from field: int64 company_staff_id = 24;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: double tax_rate = 25;
   */
  taxRate: number;

  /**
   * @generated from field: double total_amount = 26;
   */
  totalAmount: number;

  /**
   * @generated from field: string format_type = 27;
   */
  formatType: string;

  /**
   * format_typeがsingleの場合details、multipleの場合detail_groupsがセットされる
   *
   * @generated from field: repeated api_proto.v1.InvoiceDetail details = 28;
   */
  details: InvoiceDetail[];

  /**
   * @generated from field: repeated api_proto.v1.InvoiceDetailGroup detail_groups = 29;
   */
  detailGroups: InvoiceDetailGroup[];

  /**
   * @generated from field: google.protobuf.Timestamp payment_at = 30;
   */
  paymentAt?: Timestamp;

  /**
   * @generated from field: optional api_proto.v1.DocumentDealResponse deal = 31;
   */
  deal?: DocumentDealResponse;

  /**
   * 端数調整
   *
   * 端数調整(税抜)
   *
   * @generated from field: int64 adjustment = 32;
   */
  adjustment: bigint;

  /**
   * 端数調整(税込)
   *
   * @generated from field: int64 adjustment_tax = 33;
   */
  adjustmentTax: bigint;

  /**
   * 調整後合計金額
   *
   * @generated from field: double adjusted_total_amount = 34;
   */
  adjustedTotalAmount: number;

  /**
   * レイアウトタイプ: normal=通常, windowed=窓付封筒
   *
   * @generated from field: string layout_type = 35;
   */
  layoutType: string;

  /**
   * 振込手数料の負担者。帳票の振込先欄の直下に注意書きとして表示する
   * ""=表示しない / "customer"=先方負担 / "company"=当方負担
   *
   * @generated from field: string transfer_fee_bearer = 36;
   */
  transferFeeBearer: string;
};

/**
 * Describes the message api_proto.v1.GetInvoiceResponse.
 * Use `create(GetInvoiceResponseSchema)` to create a new message.
 */
export const GetInvoiceResponseSchema: GenMessage<GetInvoiceResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 10);

/**
 * @generated from message api_proto.v1.UpdateInvoiceRequest
 */
export type UpdateInvoiceRequest = Message<"api_proto.v1.UpdateInvoiceRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: google.protobuf.StringValue name = 2;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue number = 3;
   */
  number?: string;

  /**
   * @generated from field: google.protobuf.Timestamp invoice_at = 4;
   */
  invoiceAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp expire_at = 5;
   */
  expireAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue remark = 6;
   */
  remark?: string;

  /**
   * @generated from field: string company_name = 7;
   */
  companyName: string;

  /**
   * @generated from field: google.protobuf.StringValue company_address = 8;
   */
  companyAddress?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_contact = 9;
   */
  companyContact?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_registration_number = 10;
   */
  companyRegistrationNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_bank_account = 11;
   */
  companyBankAccount?: string;

  /**
   * @generated from field: google.protobuf.Int64Value company_logo_id = 12;
   */
  companyLogoId?: bigint;

  /**
   * @generated from field: google.protobuf.Int64Value company_seal_id = 13;
   */
  companySealId?: bigint;

  /**
   * @generated from field: int64 customer_id = 14;
   */
  customerId: bigint;

  /**
   * @generated from field: string customer_name = 15;
   */
  customerName: string;

  /**
   * @generated from field: string honorific = 16;
   */
  honorific: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_zipcode = 17;
   */
  customerZipcode?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_prefecture = 18;
   */
  customerPrefecture?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_city = 19;
   */
  customerCity?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_street = 20;
   */
  customerStreet?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_department = 22;
   */
  customerDepartment?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_contact_person = 23;
   */
  customerContactPerson?: string;

  /**
   * @generated from field: int64 company_staff_id = 24;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: string format_type = 25;
   */
  formatType: string;

  /**
   * format_typeがsingleの場合details、multipleの場合detail_groupsがセットされる
   *
   * @generated from field: repeated api_proto.v1.InvoiceDetail details = 26;
   */
  details: InvoiceDetail[];

  /**
   * @generated from field: repeated api_proto.v1.InvoiceDetailGroup detail_groups = 27;
   */
  detailGroups: InvoiceDetailGroup[];

  /**
   * @generated from field: optional google.protobuf.Timestamp payment_at = 28;
   */
  paymentAt?: Timestamp;

  /**
   * 端数調整
   *
   * 端数調整(税抜)
   *
   * @generated from field: int64 adjustment = 29;
   */
  adjustment: bigint;

  /**
   * 端数調整(税込)
   *
   * @generated from field: int64 adjustment_tax = 30;
   */
  adjustmentTax: bigint;

  /**
   * レイアウトタイプ: normal=通常, windowed=窓付封筒
   *
   * @generated from field: string layout_type = 31;
   */
  layoutType: string;

  /**
   * 振込手数料の負担者。帳票の振込先欄の直下に注意書きとして表示する
   * ""=表示しない / "customer"=先方負担 / "company"=当方負担
   *
   * @generated from field: string transfer_fee_bearer = 32;
   */
  transferFeeBearer: string;
};

/**
 * Describes the message api_proto.v1.UpdateInvoiceRequest.
 * Use `create(UpdateInvoiceRequestSchema)` to create a new message.
 */
export const UpdateInvoiceRequestSchema: GenMessage<UpdateInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 11);

/**
 * @generated from message api_proto.v1.UpdateInvoiceResponse
 */
export type UpdateInvoiceResponse = Message<"api_proto.v1.UpdateInvoiceResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * 請求書番号が重複していた場合true
   *
   * @generated from field: bool number_duplicate = 2;
   */
  numberDuplicate: boolean;
};

/**
 * Describes the message api_proto.v1.UpdateInvoiceResponse.
 * Use `create(UpdateInvoiceResponseSchema)` to create a new message.
 */
export const UpdateInvoiceResponseSchema: GenMessage<UpdateInvoiceResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 12);

/**
 * @generated from message api_proto.v1.DeleteInvoiceRequest
 */
export type DeleteInvoiceRequest = Message<"api_proto.v1.DeleteInvoiceRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteInvoiceRequest.
 * Use `create(DeleteInvoiceRequestSchema)` to create a new message.
 */
export const DeleteInvoiceRequestSchema: GenMessage<DeleteInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 13);

/**
 * @generated from message api_proto.v1.LinkDealToInvoiceRequest
 */
export type LinkDealToInvoiceRequest = Message<"api_proto.v1.LinkDealToInvoiceRequest"> & {
  /**
   * @generated from field: int64 invoice_id = 1;
   */
  invoiceId: bigint;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;

  /**
   * 書類の情報で案件を保存したいかどうか
   *
   * @generated from field: bool want_update = 3;
   */
  wantUpdate: boolean;
};

/**
 * Describes the message api_proto.v1.LinkDealToInvoiceRequest.
 * Use `create(LinkDealToInvoiceRequestSchema)` to create a new message.
 */
export const LinkDealToInvoiceRequestSchema: GenMessage<LinkDealToInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 14);

/**
 * @generated from message api_proto.v1.LinkDealToInvoiceResponse
 */
export type LinkDealToInvoiceResponse = Message<"api_proto.v1.LinkDealToInvoiceResponse"> & {
  /**
   * @generated from field: int64 invoice_id = 1;
   */
  invoiceId: bigint;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;
};

/**
 * Describes the message api_proto.v1.LinkDealToInvoiceResponse.
 * Use `create(LinkDealToInvoiceResponseSchema)` to create a new message.
 */
export const LinkDealToInvoiceResponseSchema: GenMessage<LinkDealToInvoiceResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 15);

/**
 * @generated from message api_proto.v1.CreateAndLinkDealToInvoiceRequest
 */
export type CreateAndLinkDealToInvoiceRequest = Message<"api_proto.v1.CreateAndLinkDealToInvoiceRequest"> & {
  /**
   * @generated from field: int64 invoice_id = 1;
   */
  invoiceId: bigint;

  /**
   * @generated from field: api_proto.v1.CreateDealForDocumentRequest deal = 2;
   */
  deal?: CreateDealForDocumentRequest;
};

/**
 * Describes the message api_proto.v1.CreateAndLinkDealToInvoiceRequest.
 * Use `create(CreateAndLinkDealToInvoiceRequestSchema)` to create a new message.
 */
export const CreateAndLinkDealToInvoiceRequestSchema: GenMessage<CreateAndLinkDealToInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 16);

/**
 * @generated from message api_proto.v1.UnlinkDealFromInvoiceRequest
 */
export type UnlinkDealFromInvoiceRequest = Message<"api_proto.v1.UnlinkDealFromInvoiceRequest"> & {
  /**
   * @generated from field: int64 invoice_id = 1;
   */
  invoiceId: bigint;
};

/**
 * Describes the message api_proto.v1.UnlinkDealFromInvoiceRequest.
 * Use `create(UnlinkDealFromInvoiceRequestSchema)` to create a new message.
 */
export const UnlinkDealFromInvoiceRequestSchema: GenMessage<UnlinkDealFromInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_invoice, 17);

